import { IQuote } from '../api/homeServices/types';

export const filterQuotesByExcess = (
  quotes: IQuote[],
  excess: number | number[],
) => {
  if (Array.isArray(excess)) {
    return quotes.filter(quote => excess.includes(quote.excess));
  }
  return quotes.filter(quote => quote.excess === excess);
};
